import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const HomeReportRedux = createActions(
  {
    postHomeReportRequest: ['studentId', 'data'],
    postHomeReportSuccess: ['data'],
    postHomeReportError: ['error'],
    getHomeReportStudentRequest: ['studentId'],
    getHomeReportStudentSuccess: ['data'],
    getHomeReportStudentError: ['error'],
  },
  {
    prefix: 'HOME_REPORT_',
    defaultActions: {},
  },
)

const { Types, Creators } = HomeReportRedux
export const HomeReportTypes = Types
export default Creators

export const INITIAL_STATE = createState(
  {
    send_home_report: {
      error: '',
      success: false,
      fetching: false,
    },
    student_home_report:{
      error:'',
      fetching:false,
      result:[]
    }
  }, {})

const postHomeReportRequest = state => state.merge({
  send_home_report: {
    fetching: true,
    error: '',
    success: false,
  },
}, d)

const postHomeReportError = (state, { err }) => state.merge({
  send_home_report: {
    fetching: false,
    error: err,
    success: false,
  },
}, d)

const postHomeReportSuccess = (state, data) => state.merge({
  send_home_report: {
    success: true,
    fetching: false,
    error: '',
  },
}, d)

const getHomeReportStudentRequest = state => state.merge({
  student_home_report: {
    fetching: true,
    error: '',
    result: [],
  },
}, d)

const getHomeReportStudentError = (state, { error }) => state.merge({
  student_home_report: {
    fetching: false,
    error: error,
    result: [],
  },
}, d)

const getHomeReportStudentSuccess = (state, {data}) => state.merge({
  student_home_report: {
    result: data,
    fetching: false,
    error: '',
  },
}, d)

export const reducer = createReducer(
  INITIAL_STATE,
  {
    [Types.postHomeReportRequest]: postHomeReportRequest,
    [Types.postHomeReportSuccess]: postHomeReportSuccess,
    [Types.postHomeReportError]: postHomeReportError,
    [Types.getHomeReportStudentRequest]: getHomeReportStudentRequest,
    [Types.getHomeReportStudentSuccess]: getHomeReportStudentSuccess,
    [Types.getHomeReportStudentError]: getHomeReportStudentError,
  },
  {
    defaultActions: {},
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/HomeReportRedux.js